import { ref } from 'vue'

/**
 * Geteilter Zustand für den globalen Routen-Fortschrittsindikator.
 *
 * router.ts (beforeEach/afterEach) ruft `startRouteProgress()` / `stopRouteProgress()` auf.
 * RouteProgressBar.vue liest lediglich `isRouteProgressVisible` und rendert entsprechend.
 *
 * Gesteuert über FEATURE_FLAGS.ROUTE_PROGRESS_INDICATOR:
 * - ENABLED: schaltet den Indikator global ein/aus (Default: false)
 * - DELAY_MS: Verzögerung bevor der Balken sichtbar wird, um Flackern bei schnellen
 *   Routenwechseln zu vermeiden (Default: 200)
 */
export const isRouteProgressVisible = ref(false)

let delayTimeoutId: ReturnType<typeof setTimeout> | undefined

function clearDelayTimeout(): void {
  if (delayTimeoutId !== undefined) {
    clearTimeout(delayTimeoutId)
    delayTimeoutId = undefined
  }
}

export function startRouteProgress(): void {
  const featureFlag = globalThis.ENV_CONFIG?.FEATURE_FLAGS?.ROUTE_PROGRESS_INDICATOR
  if (!featureFlag?.ENABLED) return

  clearDelayTimeout()
  delayTimeoutId = setTimeout(() => {
    isRouteProgressVisible.value = true
  }, featureFlag.DELAY_MS ?? 200)
}

export function stopRouteProgress(): void {
  clearDelayTimeout()
  isRouteProgressVisible.value = false
}
